import { Injectable } from '@angular/core';

@Injectable()
export class DialogExportService {
    alert: (message?: string, title?: string) => Promise<void>;
    confirm: (message?: string, title?: string, details?: string) => Promise<void>;
    csvCheck: boolean;
    prgCheck: boolean;
}